import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useFeatureFlag } from '../hooks/useFeatureFlags';

interface FeatureGuardProps {
    featureKey: string;
    children: React.ReactNode;
    fallback?: React.ReactNode;
    loadingComponent?: React.ReactNode;
}

const FeatureGuard: React.FC<FeatureGuardProps> = ({
    featureKey,
    children,
    fallback,
    loadingComponent,
}) => {
    const { isLoaded, isEnabled } = useFeatureFlag(featureKey);

    // Show loading state while features are being loaded
    if (!isLoaded) {
        return (
            loadingComponent || (
                <Box display="flex" justifyContent="center" alignItems="center">
                    <CircularProgress size={24} sx={{ strokeWidth: 2 }} />
                </Box>
            )
        );
    }

    // Show children if feature is enabled
    if (isEnabled) {
        return <>{children}</>;
    }

    // Show fallback or nothing if feature is disabled
    return <>{fallback || null}</>;
};

export default FeatureGuard;
